import { render, staticRenderFns } from "./layoutmenu.vue?vue&type=template&id=4be34128"
import script from "./layoutmenu.vue?vue&type=script&lang=js"
export * from "./layoutmenu.vue?vue&type=script&lang=js"
import style0 from "./layoutmenu.vue?vue&type=style&index=0&id=4be34128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports